// src/redux/actions/resetActions.js
export const RESET_ALL = "RESET_ALL";

export const resetAll = () => ({
    type: RESET_ALL
});
